// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1XI6h","info":"PatientInfo_info__1OjkX"};